'use strict';
(function () {

    var _ = require('lodash'),
        gasp = require('gsap'),
        tpl = require('./templates/question.nunj'),
        AbstractView = require('./abstractview');


    var gs = window.GreenSockGlobals || {},
        _initTimeline = function () {
            var bg = document.getElementById('bg-container').querySelector('.bg:last-child'),
                ul = this.el.querySelector('ul'),
                h2 = ul.querySelector('li.heading h2'),
                lis = ul.querySelectorAll('li');
            var tl = new gs.TimelineMax();
            tl.to(ul, 1, {
                width: '100%',
                delay: 0,
                ease: Quart.easeInOut
            });
            tl.to(h2, 2, {
                y: 0,
                delay: 0,
                ease: Back.easeInOut
            }, '-=1.4');
            var offset = 0.7;
            _.each(lis, function (li, index) {
                if (index > 0) {
                    tl.to(li, 1, {
                        y: 0,
                        opacity: 1,
                        ease: Back.easeInOut
                    }, '-=0.85');
                }
            });
            return tl;
        };

    var QuizView = function () {
        AbstractView.call(this);
        this.el = document.getElementById('quiz');
    };

    QuizView.prototype = _.assign({

        name: 'quiz-view',

        _onresize: function () {
            var bg = document.querySelector('#bg-container .bg:first-child');
            gs.TweenMax.set(bg, {x:window.innerWidth});
        },
        
        _onreversecomplete: function(data){
            this.init(data);
            this.tl.timeScale(1);
            this.tl.play();
        },
        _onplayoutcomplete:function(){
            this.el.style.display = 'none';
        },
        
        init:function(data){
            this.el.innerHTML = tpl.render(data);
            this.tl = _.bind(_initTimeline, this)();
        },
        
        update:function(data){
            this.tl.timeScale(2);
            this.tl.reverse();
            this.tl.eventCallback("onReverseComplete", this._onreversecomplete, [data], this);
        },
        
        addEventListeners: function () {
            window.addEventListener('resize', this._onresize);
        },
        removeEventListeners: function () {
            window.removeEventListener('resize', this._onresize);
        },
    }, AbstractView.prototype, {

        playIn: function () {
            
            this.addEventListeners();
            var bg = document.getElementById('bg-container').querySelector('.bg:last-child');

            gs.TweenMax.set(bg, {
                x: -window.innerWidth,
                y:0,
                display:'block',
                backgroundColor: '#C33149'
            });
            gs.TweenMax.set(this.el, {
                display: 'block'
            });
            
            
            gs.TweenMax.to(bg, 1, {
                x: 0,
                delay: 0.25,
                ease: Quart.easeInOut
            });
            
            this.tl.eventCallback("onReverseComplete", null);
            
            this.tl.timeScale(1);
            this.tl.play();
        },
        playOut: function () {
            this.removeEventListeners();
            
            var bg = document.getElementById('bg-container').querySelector('.bg:last-child');
            
            gs.TweenMax.to(bg, 1, {
                x: window.innerWidth,
                delay: 0.25,
                onComplete:function(){
                    bg.style.display = "none";
                },
                ease: Quart.easeInOut
            });
            
            this.tl.eventCallback("onReverseComplete", _.bind(this._onplayoutcomplete, this));
            
            this.tl.timeScale(2);
            this.tl.reverse();
        }
    });

    module.exports = QuizView;


}());


/** WEBPACK FOOTER **
 ** ./holiday-map/quiz.js
 **/